const StoreFileReducers = (state = {}, action) => {
  switch (action.type) {
    case "uploadFile":
      return action.payload;
    default:
      return state;
  }
};
export default StoreFileReducers;
